import ClientStatusTag from './client-status-tag';

export default ClientStatusTag;
